<template>
  <div class="lms-sidebar">
    <div id="particles-js"></div>
    <div class="lms-sidebar-header">
      <router-link to="/" class="dropdown-link pd-t-20" style="padding-left:15px">
        <div v-if="settedOrg.hasValue" class="d-flex align-items-center justify-content-center wd-100p">
        
          <img
              class="mg-r-10"
              :src="`${myResBaseUrl}${settedOrg.obj.logo}?w=50`"
            />
            <span class="tx-12 tx-color-01 tx-semibold lh-1">{{
              settedOrg.obj.name
          }}</span>
        </div>
        <div v-else-if="$store.state.app.activeGroup.id==9311" class="d-flex align-items-center justify-content-center wd-100p">
          <img
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=400`"
            />
        </div>
        <div v-else class="d-flex align-items-center justify-content-center wd-100p">
          <div v-if="$store.state.app.activeGroup.id==9235" class="">
            <img
              class="mg-r-10"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=50`"
            />
          </div>
          <div v-else-if="$store.state.app.activeGroup.id==9362" class="">
            <img
              class="mg-r-10"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=50`"
            />
          </div>
          <div v-else-if="$store.state.app.activeGroup.id==9368" class="">
            <img
              class="mg-r-10"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=50`"
            />
          </div>
          <div v-else-if="$store.state.app.activeGroup.id==9351" class="">
            <img
              class="mg-r-10"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=100`"
            />
          </div>
          <div v-else-if="$store.state.app.activeGroup.id==9363" class="">
            <img :src="`${myResBaseUrl}${$store.state.app.activeGroup.logowt}?w=100`" class="mg-r-10" />
          </div>
          <div v-else-if="$store.state.app.activeGroup.id==9352" class="">
            <img :src="`${myResBaseUrl}${$store.state.app.activeGroup.logowt}?w=183`" />
          </div>
          <div v-else-if="$store.state.app.activeGroup.id==9265" class="">
            <img
              class="mg-r-10"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=183`"
            />
          </div>
          <div v-else-if="$store.state.app.activeGroup.id==9157" class="">
            <img class="" style="width: 210px"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=400`"
            />
          </div>
          <div v-else-if="$store.state.app.activeGroup.id==9356" class="">
            <img class="" style="width: 210px"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=400`"
            />
          </div>
          <div v-else-if="$store.state.app.activeGroup.id==9357" class="">
            <img class="" style="width: 210px"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=400`"
            />
          </div>
          <div v-else-if="$store.state.app.activeGroup.id==9358" class="">
            <img class="" style="width: 30px"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=30`"
            />
          </div>
          <div v-else-if="$store.state.app.activeGroup.id==9379" class="">
            <img class="" style=""
              :src="`${myResBaseUrl}/media/logo/gazar_logo_white.png`"
            />
          </div>
          <div v-else class="avatar avatar-sm mg-r-8">
            <img
              class="mg-r-10"
              v-if="!$store.state.app.skin.dark"
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}?w=60`"
              :style="`max-width: 60px; max-height: 50px`"
            />
          </div>
          <span v-if="$store.state.app.activeGroup.id==9235" class="tx-18 tx-color-01 tx-semibold lh-1">{{
            $store.state.app.activeGroup.name
          }}</span>
          <span v-else-if="$store.state.app.activeGroup.id==9362" class="tx-14 tx-color-01 tx-semibold lh-1">{{
            $store.state.app.activeGroup.name
          }}</span>
          <span v-else-if="$store.state.app.activeGroup.id==9368" class="tx-12 tx-color-01 tx-semibold lh-1">{{
            $store.state.app.activeGroup.name
          }}</span>
          <span v-else-if="$store.state.app.activeGroup.id==9351" class="tx-14 tx-color-01 tx-semibold lh-1">{{
            $store.state.app.activeGroup.name
          }}</span>
          <span v-else-if="$store.state.app.activeGroup.id==9363" class="tx-14 tx-color-01 tx-semibold lh-1">{{
            $store.state.app.activeGroup.name
          }}</span>
          <span v-else-if="$store.state.app.activeGroup.id==9157"></span>
          <span v-else-if="$store.state.app.activeGroup.id==9379"></span>
          <span v-else-if="$store.state.app.activeGroup.id==9352 || $store.state.app.activeGroup.groupNameHide==true" class="tx-14 tx-color-01 tx-semibold lh-1"></span>
          <span v-else class="tx-16 tx-color-01 tx-semibold lh-1 grpname-white">{{
            $store.state.app.activeGroup.nameShort!=undefined && $store.state.app.activeGroup.nameShort!='' 
            ? $store.state.app.activeGroup.nameShort : $store.state.app.activeGroup.name
          }}</span>
        </div>
      </router-link>
    </div>
    <div class="lms-sidebar-body">
      <vue-custom-scrollbar
        style="height: calc(100vh - 120px)"
        class="pd-x-20 pd-b-20"
      >
      
        <ul class="sidebar-nav lms-nav">
          <li class="nav-item">
            <a class="nav-link nav-descr">
              МЕНЮ
            </a>
          </li>
          <li class="nav-item" v-if="navs.home">
            <router-link
              :to="{ name: 'lmsParticipant' }"
              class="nav-link home"
              :class="{ active: $route.name == 'lmsParticipant' }"
              role="button"
            >
              <!-- <svg-icon type="home" :active="$route.name == 'lmsParticipant'" fill="#eb4872" stroke="#adb1bd"></svg-icon> -->
              Нүүр
            </router-link>
          </li>
          <li class="nav-item" :class="{ show: courseNavExpanded() }">
            <router-link
              :to="{
                name: 'lmsCourses',
                params: {
                  md: 1,
                  cnm: 'null',
                  type: -1,
                  d1: 'null',
                  d2: 'null',
                },
              }"
              class="nav-link course "
              :class="{
                active:
                  $route.name == 'lmsCourses' ||
                  $route.name == 'lmsAttend' ||
                  $route.name == 'lmsCourseView',
              }"
              role="button"
              data-svg=""
            >
              <!-- <svg-icon type="learn" :active="$route.name == 'lmsCourses' || $route.name == 'lmsAttend'" fill="red" stroke="#adb1bd"></svg-icon>  -->
              Сургалтууд
            </router-link>
            <nav class="nav" v-if="courseNavExpanded()">
              <a v-if="$store.state.app.activeGroup.id == 9157" class="mt-3 bg-white tx-semibold" style="margin-left: -25px; border-radius: 0 5px 0 0">
                <span class="d-block" style="margin-left: 0">МНБ-ийн сургалт</span>
              </a>
              <router-link
                :to="{
                  name: 'lmsCourses',
                  params: {
                    md: 1,
                    cnm: 'null',
                    type: -1,
                    d1: 'null',
                    d2: 'null',
                  },
                }"
                :class="{ active: ($route.params.md == 1 && $route.params.type==-1) }"
                role="button"
              >
                <span
                  >Бүх нээлттэй сургалт
                  <sup v-if="counts != undefined">{{ counts.allCount }}</sup>
                </span>
              </router-link>
              <router-link v-if="$store.state.app.activeGroup.id==9241  || $store.state.app.activeGroup.id==9249"
                :to="{
                  name: 'lmsCourses',
                  params: {
                    md: 2,
                    cnm: 'null',
                    type: -1,
                    d1: 'null',
                    d2: 'null',
                  },
                }"
                :class="{ active: $route.params.md == 2 }"
                role="button"
              >
                <span
                  >Заавал хамрагдах сургалт
                  <sup v-if="counts != undefined">{{
                    counts.mustJoinCount
                  }}</sup>
                </span>
              </router-link>
              
              <template v-if="1!==1 && ($store.state.app.activeGroup.id==9241  || $store.state.app.activeGroup.id==9249) && $route.params.md == 2">
                <a :class="`${zaaval?.mode===1?'tx-bold':''}`" href="javascript:void(0)" @click="$emit('on-zaaval', 1)" >
                  <span class="pl-4 bd-l-2 border-gray-600">Үзэж буй - {{ zaaval.viewing }}</span>
                </a>
                <a :class="`${zaaval?.mode===2?'tx-bold':''}`" href="javascript:void(0)" @click="$emit('on-zaaval', 2)" >
                  <span class="pl-4 bd-l-2 border-gray-600">Бүртгүүлээгүй - {{ zaaval.notRegistered }}</span>
                </a>
                <a :class="`${zaaval?.mode===3?'tx-bold':''}`" href="javascript:void(0)" @click="$emit('on-zaaval', 3)" >
                  <span class="pl-4 bd-l-2 border-gray-600">Дууссан - {{ zaaval.completed }}</span>
                </a>
                <a :class="`${zaaval?.mode===0?'tx-bold':''}`" href="javascript:void(0)" @click="$emit('on-zaaval', 0)" >
                  <span class="pl-4 bd-l-2 border-gray-600">Нийт - {{ counts?.mustJoinCount }}</span>
                </a>
              </template>

              <router-link v-if="!($store.state.app.activeGroup.id == 9241 
              || $store.state.app.activeGroup.id == 9249)"
                :to="{
                  name: 'lmsCourses',
                  params: {
                    md: 3,
                    cnm: 'null',
                    type: -1,
                    d1: 'null',
                    d2: 'null',
                  },
                }"
                :class="{ active: $route.params.md == 3 }"
                role="button"
              >
                <span
                  >Миний үзэж буй сургалт
                  <sup v-if="counts != undefined">{{ counts.joinedCount }}</sup>
                </span>
              </router-link>
              <router-link v-if="!($store.state.app.activeGroup.id == 9241 
              || $store.state.app.activeGroup.id == 9249)"
                :to="{
                  name: 'lmsCourses',
                  params: {
                    md: 4,
                    cnm: 'null',
                    type: -1,
                    d1: 'null',
                    d2: 'null',
                  },
                }"
                :class="{ active: $route.params.md == 4 }"
                role="button"
              >
                <span
                  >Миний дууссан сургалт
                  <sup v-if="counts != undefined">{{
                    counts.finishedCount
                  }}</sup>
                </span>
              </router-link>

              
              <template v-if="$store.state.app.activeGroup.id == 9157">
                <a class="mt-3 bg-white tx-semibold" style="margin-left: -25px; border-radius: 0 5px 0 0">
                  <span class="d-block" style="margin-left: 0">Академийн сургалт</span>
                </a>

                <router-link
                  :to="{
                    name: 'lmsCourses',
                    params: {
                      md: 11,
                      cnm: 'null',
                      type: -1,
                      d1: 'null',
                      d2: 'null',
                    },
                  }"
                  :class="{ active: ($route.params.md == 11 && $route.params.type==-1) }"
                  role="button"
                >
                  <span
                    >Бүх нээлттэй сургалт
                    <sup v-if="counts != undefined">{{ counts?.academyAllCount }}</sup>
                  </span>
                </router-link>

                <router-link 
                  :to="{
                    name: 'lmsCourses',
                    params: {
                      md: 33,
                      cnm: 'null',
                      type: -1,
                      d1: 'null',
                      d2: 'null',
                    },
                  }"
                  :class="{ active: $route.params.md == 33 }"
                  role="button"
                >
                  <span
                    >Миний үзэж буй сургалт
                    <sup v-if="counts != undefined">{{ counts?.academyJoinedCount }}</sup>
                  </span>
                </router-link>
                <router-link 
                  :to="{
                    name: 'lmsCourses',
                    params: {
                      md: 44,
                      cnm: 'null',
                      type: -1,
                      d1: 'null',
                      d2: 'null',
                    },
                  }"
                  :class="{ active: $route.params.md == 44 }"
                  role="button"
                >
                  <span
                    >Миний дууссан сургалт
                    <sup v-if="counts != undefined">{{
                      counts?.academyFinishedCount
                    }}</sup>
                  </span>
                </router-link>
              </template>

              <!--   -->
              <a  v-if="navcrsetypes.length && !(
                $store.state.app.activeGroup.id == 9157 
                || $store.state.app.activeGroup.id == 9241 
              || $store.state.app.activeGroup.id == 9249
                || $store.state.app.activeGroup.id == 9256)" class="mt-3 bg-white tx-semibold" style="margin-left: -25px; border-radius: 0 5px 0 0">
                <span class="d-block" style="margin-left: 0">{{lmsNavType}}</span>
              </a>

              <router-link v-for="(cin, ci) in navcrsetypes" 
              v-if="!($store.state.app.activeGroup.id==9157 || $store.state.app.activeGroup.id==9241 || $store.state.app.activeGroup.id==9249)"
              :key="`ci_${ci}`"
                :to="{
                  name: 'lmsCourses',
                  params: {
                    md: 1,
                    cnm: 'null',
                    type: cin.id,
                    d1: 'null',
                    d2: 'null',
                  },
                }"
                :class="{ active: $route.params.type == cin.id }"
                role="button" 
              >
                <span class="d-inline-block lh-2">
                  {{ cin.s1 }}
                </span>
              </router-link>

              <!-- $store.state.app.activeGroup.id==9157 ||  -->
              <a @click="examPointModal = true" role="button" 
                v-if="$store.state.app.activeGroup.id==6126 && $store.state.user.userInfo.locType4Code === 'member'">
                <span>Шалгалтын дүн харах</span>
              </a>
            </nav>
          </li>

          <!-- <li class="nav-item" v-if="hasGroup([9241,9249]) && !hasPermission(['buddy_participant', 'lmsbuddyadmin', 'buddy_worker', 'buddy_chief'])">
            <router-link
              :to="{ name: 'lmsEvent', params: { id: 0 } }" class="nav-link notepad"
              :class="{ active: $route.name == 'lmsEvent' }"
            >
            Хөтөлбөр
            </router-link>
          </li> -->

          <li class="nav-item" v-if="
          $store.state.app.activeGroup.id == 9379 || $store.state.app.activeGroup.id == 9157" :class="{ show: $route.name == 'lmsExamr' }">
            <router-link
            v-if="$store.state.app.activeGroup.id == 9379"
             :to="{ name: 'lmsExamr', params: { mode: 
              examRs.length > 0 ? 1 : -1
            , id: examRs.length > 0 ? examRs[0].id : 0 } }" class="nav-link pen" :class="{ active: $route.name == 'lmsExamr' }">
              Бүртгэл
            </router-link>
            <router-link v-else :to="{ name: 'lmsExamr', params: { mode: 
            $store.state.user.userInfo.locType4Code === 'member'? -1 : 0
            , id: 0 } }" class="nav-link pen" :class="{ active: $route.name == 'lmsExamr' }">
              Шалгалт
            </router-link>
            <!-- v-if="$route.name == 'lmsExamr'" -->
            <nav class="nav" >
              <!-- {{ $route.name == 'lmsExamr' }} -->
              <!-- {{ $store.state.user.userInfo.locType4Code }} -->
              <template v-if="$store.state.app.activeGroup.id == 9379">
                <template v-for="(ex, i) in examRs">
                  <router-link v-if="canNavigate(ex, i)" :key="`ex_${i}`"
                  :to="{ name: 'lmsExamr', params: { mode: 1, id: ex.id } }" 
                  
                  role="button" :class="{ active: $route.params.mode == 1 && $route.params.id == ex.id }">
                    <span>{{ ex.s1 }}</span>
                  </router-link>
                  <a v-else href="javascript:void(0)" :key="`ex_${i}`">
                    <span class="text-muted">{{ ex.s1 }}</span>
                  </a>
                </template>
              </template>
              <template v-else>
                <router-link v-for="(ex, i) in examRs.filter(e=>e.s3===$store.state.user.userInfo.locType4Code)" 
                  :to="{ name: 'lmsExamr', params: { mode: 1, id: ex.id } }" 
                  
                  role="button" :class="{ active: $route.params.mode == 1 && $route.params.id == ex.id }">
                    <span>{{ ex.s1 }}</span>
                </router-link>
              </template>

              <router-link :to="{ name: 'lmsExamr', params: { mode: -1, id: 0 } }" role="button" :class="{ active: $route.params.mode == -1 }">
                <span>Шалгалтын дүн харах</span>
              </router-link>
            </nav>
          </li>
          <li class="nav-item" v-if="$store.state.app.activeGroup.id == 9379 && hasPermission('gazarzuvlulhural')" >
            <router-link
              :to="{
                name: 'gazarZuvlulHural',
                params: { id: 0, cid: 0, title: 'Зөвлөлийн хурал' },
              }"
              class="nav-link comment"
              :class="{ active: $route.name == 'gazarZuvlulHural' }"
            >
              Зөвлөлийн хурал
            </router-link>
          </li>
          
          <li class="nav-item" v-if="$store.state.app.activeGroup.id == 9352" >
            <router-link
              :to="{ name: 'lmsExternalCourse', params: { title: 'Гадны сургалтын мэдээлэл' } }" class="nav-link notepad"
              :class="{ active: $route.name == 'lmsExternalCourse' }"
            >
            Гадны сургалтын мэдээлэл
            </router-link>
          </li>
          
          <li class="nav-item" v-if="$store.state.app.activeGroup.id == 9235 && settedOrg.obj.id!=9351 && settedOrg.obj.id!=9368 && settedOrg.obj.id!=9362 && $store.state.app.activeGroup.id!=9363" >
            <router-link
              :to="{
                name: 'lmsSanamj',
                params: { id: 0, cid: 0, title: 'Машинчийн санамж' },
              }"
              class="nav-link notepad"
              :class="{ active: $route.name == 'lmsSanamj' }"
            >
              Машинчийн санамж
            </router-link>
          </li>

          <li class="nav-item" v-if="$store.state.app.activeGroup.id == 9235 && settedOrg.obj.id!=9351 && settedOrg.obj.id!=9368 && settedOrg.obj.id!=9362 && $store.state.app.activeGroup.id!=9363" >
            <router-link
              :to="{ name: 'lmsAssign', params: { id: 0, cid: 0, title: 'Үүрэг даалгавар' }, }"
              class="nav-link comment" :class="{ active: $route.name == 'lmsAssign' }">
              Үүрэг даалгавар
            </router-link>
          </li>
          
          <!-- v-if="$store.state.app.activeGroup.id==9235" -->
          <li
            class="nav-item"
            v-if="
              $store.state.app.activeGroup.id == 9235 || $store.state.app.activeGroup.id == 9368 || $store.state.app.activeGroup.id == 9362 || $store.state.app.activeGroup.id == 9351 || $store.state.app.activeGroup.id == 9363 ||
                $store.state.app.activeGroup.id == 9290 
            "
          >
            <router-link
              :to="{
                name: 'lmsNotif',
                params: { id: 0, cid: 0, title: 'Тушаал / Цахилгаан' },
              }"
              class="nav-link ringing"
              :class="{ active: $route.name == 'lmsNotif' }"
            >
              <!-- <feather type="bell"></feather> -->
              Тушаал / Цахилгаан
            </router-link>
          </li>
          <li
            class="nav-item"
            v-if="
              !(
                $store.state.app.activeGroup.id == 9358 ||
                $store.state.app.activeGroup.id == 9241 ||
                $store.state.app.activeGroup.id == 9249 ||
                $store.state.app.activeGroup.id == 9235 || 
                $store.state.app.activeGroup.id == 9362 ||
                $store.state.app.activeGroup.id == 9368 ||
                $store.state.app.activeGroup.id == 9351 ||
                $store.state.app.activeGroup.id == 9363 ||
                $store.state.app.activeGroup.id == 9379
              ) && $store.state.user.userInfo.locType4Code == 'member'
            "
            :class="{
              show:
                $route.name == 'lmsMembership' ||
                $route.name == 'lmsMembershipEthic' ||
                $route.name == 'lmsMembershipOrg' ||
                $route.name == 'lmsMembershipPayment' ||
                $route.name == 'lmsParticipant' ||
                $route.name == 'lmsLegalList',
            }"
          >
            <router-link v-if="$store.state.app.activeGroup.id != 9379"
              :to="{ name: 'lmsMembershipEthic' }"
              class="nav-link profile"
              :class="{
                active:
                  $route.name == 'lmsMembership' ||
                  $route.name == 'lmsMembershipEthic' ||
                  $route.name == 'lmsMembershipOrg' ||
                  $route.name == 'lmsMembershipPayment' ||
                  $route.name == 'lmsLegalList',
              }"
            >
              <!-- <feather type="award"></feather> -->
              Гишүүнчлэлийн систем
            </router-link>
            <nav
              class="nav"
              v-if="
                $route.name == 'lmsMembership' ||
                  $route.name == 'lmsMembershipEthic' ||
                  $route.name == 'lmsMembershipOrg' ||
                  $route.name == 'lmsMembershipPayment' ||
                  ($store.state.app.activeGroup.id == 9157 ? false : $route.name == 'lmsParticipant') ||
                  $route.name == 'lmsLegalList'
              "
            >
              <!-- <router-link
            to="/lms/membership"
            role="button"
            :class="{'active': $route.name=='lmsMembership' }"
          >
            <span>Эхлэл</span>
          </router-link>-->
              <router-link
                to="/lms/membershipEthic"
                role="button"
                :class="{ active: $route.name == 'lmsMembershipEthic' }"
              >
                <span>Ёс зүйн тайлан</span>
              </router-link>
              <a @click="miniMHVA= true" role="button" v-if="$store.state.user.userInfo.locType4Code == 'member'
              && $store.state.app.activeGroup.id == 9157
              " title="Мэргэжлийн хөгжлийн үйл ажиллагаа" alt="Мэргэжлийн хөгжлийн үйл ажиллагаа">
                <span>Мэргэжлийн Х.Ү.А</span>
              </a>
              <router-link
                v-if="hasPermission('crmclient')"
                to="/lms/membershipOrg"
                role="button"
                :class="{ active: $route.name == 'lmsMembershipOrg' }"
              >
                <span>Гишүүн байгууллага</span>
              </router-link>
              <router-link
                to="/lms/membershipPayment"
                role="button"
                :class="{ active: $route.name == 'lmsMembershipPayment' }"
              >
                <span>Гишүүнчлэлийн төлбөр</span>
              </router-link>
              <router-link
                to="/lms/legalList/0"
                role="button"
                :class="{ active: $route.name == 'lmsLegalList' }"
              >
                <span>Дүрэм журам</span
                ><span v-show="$store.state.app.activeGroup.id == 6126"
                  >, Тайлан</span
                >
              </router-link>
              <!-- v-if="$store.state.app.activeGroup.id == 9157 && $store.state.user.userInfo.locType4Code == 'member'" -->
              <a @click="miniEthic= true" role="button" v-if="$store.state.user.userInfo.locType4Code == 'member'">
                <span>Үүргийн тайлан</span>
              </a>
            </nav>
          </li>

          <li class="nav-item" v-if="$store.state.app.activeGroup.id == 9379 && $store.state.user.userInfo.locType4Code == 'member'" >
            <a @click="miniEthic= true" role="button" class="nav-link comment" >
              Лицензийн мэдээлэл
            </a>
          </li>

          <li
            v-if="hasPayment && (
              $store.state.app.activeGroup.id !== 9358 && 
              $store.state.app.activeGroup.id != 9344 &&
              $store.state.app.activeGroup.id != 9379 &&
              $store.state.app.activeGroup.id != 9249 && !($store.state.app.activeGroup.id == 9311
            && $store.state.user.userId =='4566c952-a7ea-4c2f-8200-a59de3fcb039'))"
            class="nav-item"
            :class="{ show: $route.name == 'lmsPaymentList' }"
          >
            <router-link
              :to="{ name: 'lmsPaymentList', params: { status: $store.state.app.activeGroup.id==9132?1:0, cur: 0 } }"
              class="nav-link invoice "
              :class="{ active: $route.name == 'lmsPaymentList' }"
            >
              <!-- <feather type="credit-card"></feather> -->
              {{$store.state.app.activeGroup.id==9132?'И-баримт':'Төлбөрийн нэхэмжлэхүүд'}}
            </router-link>
            <nav class="nav" v-if="$route.name == 'lmsPaymentList'">
              <router-link
                to="/lms/paymentList/0"
                role="button"
                :class="{ active: this.$route.params.status == 0, cur: 0 }"
              >
                <span>Төлөгдөөгүй</span>
              </router-link>
              <router-link
                v-if="hasEbarimt"
                to="/lms/paymentList/1"
                role="button"
                :class="{ active: this.$route.params.status == 1, cur: 0 }"
              >
                <span>И-Баримт</span>
              </router-link>
              <router-link
                to="/lms/paymentList/2"
                role="button"
                :class="{ active: this.$route.params.status == 2, cur: 0 }"
              >
                <span>Бүгд</span>
              </router-link>
            </nav>
          </li>
          <li class="nav-item" :class="{ show: $route.name == 'lmsLibrary' }" 
          v-if="$store.state.app.activeGroup.id !== 9157 && $store.state.app.activeGroup.id !== 9358 && navs.library">
            <router-link
              :to="{
                name: 'lmsLibrary',
                params: { id: 0, cid: 0, title: 'Номын сан', m: 101 },
              }"
              class="nav-link book"
              :class="{ active: $route.name == 'lmsLibrary' }"
            >
              <!-- <feather type="book-open"></feather> -->
              <!-- <svg-icon type="book" stroke="#adb1bd"></svg-icon> -->
              Номын сан
            </router-link>
            <nav class="nav" v-if="$route.name == 'lmsLibrary'">
              <router-link v-if="!($store.state.app.activeGroup.id == 9241 
              || $store.state.app.activeGroup.id == 9249)"
                to="/lms/library/0/0/null/101"
                role="button"
                :class="{ active: this.$route.params.m == 101 }"
              >
                <span>Бүх ном</span>
              </router-link>
              <router-link v-if="!($store.state.app.activeGroup.id == 9241 
              || $store.state.app.activeGroup.id == 9249)"
                to="/lms/library/0/0/null/102"
                role="button"
                :class="{ active: this.$route.params.m == 102 }"
              >
                <span>Цахим ном</span>
              </router-link>
              <router-link
                to="/lms/library/0/0/null/103"
                role="button"
                :class="{ active: this.$route.params.m == 103 }"
              >
                <span>Биет ном</span>
              </router-link>
              <div v-if="$store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249">
                <a @click="navbktypesCur= null; $emit('on-filter', null )" role="button" :class="`${navbktypesCur==null?'text-primary':''} pd-y-2-f pd-x-0-f`">Бүх төрөл</a>
                <a @click="navbktypesCur= t.id; $emit('on-filter', t.id )" role="button" v-for="(t,i) in navbktypes" :class="`${navbktypesCur==t.id?'text-primary':''} mg-t-0-f pd-y-3-f pd-x-0-f`">{{ t.s1 }}</a>
              </div>
              <template v-if="hasPermission('learnlibraryorder')">
                <router-link
                  to="/lms/library/0/0/null/4"
                  role="button"
                  :class="{ active: this.$route.params.m == 4 }"
                >
                  <span>Номын сангийн хяналт</span>
                </router-link>
                <!-- <router-link to="/lms/libraryOrder/504/0/0" role="button">
                  <span>Захиалгууд</span>
                </router-link>
                <router-link to="/lms/libraryAdmin/181/0/0" role="button">
                  <span>Номууд</span>
                </router-link> -->
              </template>
          <!-- <template v-else>
            <router-link
              to="/lms/library/0/0/null/0"
              role="button"
              :class="{ active: this.$route.params.m == 0 }"
            >
              <span>Цахим номууд</span>
              <span v-if="obj.rdy" class="badge">{{
                obj.data.book.digitalCount
              }}</span>
            </router-link>
            <router-link
              to="/lms/library/0/0/null/1"
              role="button"
              :class="{ active: this.$route.params.m == 1 }"
            >
              <span>Номын сан / Захиалга</span>
              <span v-if="obj.rdy" class="badge">{{
                obj.data.book.libraryCount
              }}</span>
            </router-link>
            <router-link
              to="/lms/library/0/0/null/2"
              role="button"
              :class="{ active: this.$route.params.m == 2 }"
            >
              <span>Миний номууд</span>
              <span
                v-if="obj.rdy && obj.data.order.acceptedCount > 0"
                class="badge"
                >{{ obj.data.order.acceptedCount }}/{{
                  obj.data.order.returnedCount
                }}</span
              >
            </router-link>
            <router-link
              to="/lms/library/0/0/null/3"
              role="button"
              :class="{ active: this.$route.params.m == 3 }"
            >
              <span>Захиалгын түүх</span>
              <span v-if="obj.rdy && obj.data.order.allCount > 0" class="badge"
                >{{ obj.data.order.inProgressCount }}/{{
                  obj.data.order.allCount
                }}</span
              >
            </router-link>
            
          </template> -->
            </nav>
          </li>
          <li
            class="nav-item"
            v-if="$store.state.app.activeGroup.id !== 9358 && $store.state.app.activeGroup.id != 9241 && $store.state.app.activeGroup.id != 9249"
            :class="{ show: $route.name == 'lmsEventList' }"
          >
            <router-link
              :to="{ name: 'lmsEventList', params: { status: 0 } }"
              class="nav-link event"
              :class="{ active: $route.name == 'lmsEventList' }"
            >
              <!-- <feather type="calendar"></feather> -->
              <!-- <svg-icon type="event" stroke="#adb1bd"></svg-icon> -->
              Үйл явдлууд
            </router-link>
            <nav class="nav" v-if="$route.name == 'lmsEventList'">
              <router-link
                to="/lms/eventList/0"
                role="button"
                :class="{ active: this.$route.params.status == 0 }"
              >
                <span>Нээлттэй</span>
              </router-link>
              <router-link
                to="/lms/eventList/1"
                role="button"
                :class="{ active: this.$route.params.status == 1 }"
              >
                <span>Оролцсон</span>
              </router-link>
            </nav>
          </li>
          <li class="nav-item" v-if="navs.calendar && $store.state.app.activeGroup.id !== 9358 &&  $store.state.app.activeGroup.id != 9157">
            <router-link
              :to="{ name: 'lmsCalendar' }"
              class="nav-link calendar"
              :class="{ active: $route.name == 'lmsCalendar' }"
            >
              <!-- <feather type="calendar"></feather> -->
              <!-- <svg-icon type="calendar" stroke="#adb1bd"></svg-icon> -->
              Календарь
            </router-link>
          </li>
          <li
            v-if="$store.state.app.activeGroup.id !== 9358 && $store.state.app.activeGroup.id != 9241 
            && $store.state.app.activeGroup.id != 9249 && $store.state.app.activeGroup.id != 9379"
            class="nav-item"
            :class="{
              show:
                $route.name == 'lmsResearchList' ||
                $route.name == 'lmsMagazineList' ||
                $route.name == 'lmsNewsList' ||
                (($route.name == 'lmsLibrary' || $route.params.m == 101) && $store.state.app.activeGroup.id == 9157)
            }"
          >
            <router-link
              :to="{ name: 'lmsResearchList', params: { cid: 0 } }"
              class="nav-link magazine"
              :class="{
                active:
                  $route.name == 'lmsResearchList' ||
                  $route.name == 'lmsMagazineList' ||
                  $route.name == 'lmsNewsList',
              }"
            >
              <!-- <feather type="book-open"></feather> -->
              <!-- <svg-icon type="magazine" stroke="#adb1bd"></svg-icon> -->
              
              {{ $store.state.app.activeGroup.id === 9157?'Цахим хэвлэл':'Судалгаа, Сонин сэтгүүл, мэдээлэл' }}
            </router-link>
            <nav
              class="nav"
              v-if="
                $route.name == 'lmsResearchList' ||
                  $route.name == 'lmsMagazineList' ||
                  $route.name == 'lmsNewsList' ||
                  (($route.name == 'lmsLibrary' || $route.params.m == 101) && $store.state.app.activeGroup.id == 9157)
              "
            >
              <router-link
                to="/lms/magazineList/0"
                role="button"
                :class="{ active: $route.name == 'lmsMagazineList' }"
              >
                <span>{{ $store.state.app.activeGroup.id === 9157?'Сэтгүүл':'Сонин сэтгүүл' }}</span>
              </router-link>
              <router-link
                to="/lms/researchList/0"
                role="button"
                :class="{ active: $route.name == 'lmsResearchList' }"
              >
                <span>Судалгааны ажлууд</span>
              </router-link>
              
              <router-link v-if="$store.state.app.activeGroup.id == 9157"
                to="/lms/library/0/0/null/101"
                role="button"
                :class="{ active: $route.name == 'lmsLibrary' || $route.params.m == 101 }"
              >
                <span>Цахим ном</span>
              </router-link>
              <router-link v-else
                to="/lms/newsList/0"
                role="button"
                :class="{ active: $route.name == 'lmsNewsList' }"
              >
                <span>Мэдээ мэдээлэл</span>
              </router-link>
            </nav>
          </li>
          <li class="nav-item" v-if="auditrequestindex > 0">
            <router-link
              :to="{ name: 'lmsAuditLicenseRequest', params: { id: 0 } }"
              class="nav-link lock"
              :class="{ active: $route.name == 'lmsAuditLicenseRequest' }"
            >
              <!-- <feather type="file-plus"></feather> -->
              Аудиторын тусгай зөвшөөрлийн хүсэлт
            </router-link>
          </li>
          <li class="nav-item" v-if="hasFeedback > 0">
            <router-link
              :to="{ name: 'lmsFeedback', params: { cid: 0 } }"
              class="nav-link comment"
              :class="{ active: $route.name == 'lmsFeedback' }"
            >
              <!-- <feather type="send"></feather> -->
              Санал хүсэлт
            </router-link>
          </li>
          <li
            class="nav-item"
            v-if="
              $store.state.app.activeGroup.id == 6126 &&
                $store.state.user.userInfo.locType4Code != 'member'
            "
          >
            <router-link
              :to="{ name: 'lmsConfirm', params: { title: 'Батламж' } }"
              class="nav-link"
              :class="{ active: $route.name == 'lmsConfirm' }"
            >
              <!-- <feather type="award"></feather> -->
              Батламж
            </router-link>
          </li>

          <li class="nav-item" v-if="$store.state.app.activeGroup.id !== 9358 && $store.state.app.activeGroup.id != 9157">
            <router-link
              :to="{ name: 'lmsProfile', params: { id: 0 } }"
              class="nav-link profile"
              :class="{ active: $route.name == 'lmsProfile' }"
            >
              <!-- <feather type="file-plus"></feather> -->
              Миний сургалтууд
            </router-link>
          </li>
        </ul>

        <nav-buddy v-if="$store.state.app.activeGroup.id !== 9358 && hasPermission(['buddy_participant', 'lmsbuddyadmin', 'buddy_worker', 'buddy_chief'])"></nav-buddy>
        
        <router-link v-if="featuredCourse.id>0" :to="{ name: 'lmsCourseView', params: { id: featuredCourse.id, bid: 0, iid: 0, bot: 0 }, }">
          <div class="text-center bg-white rounded-20 mg-t-50 pd-10">
            <div class="" style="margin-top: -50px">
              <img :src="`${myResBaseUrl}v4-assets/img2.png`" />
            </div>
            <div class="mg-t-10 text-muted">Онцлох сургалт</div>
            <h6>{{featuredCourse.name}}</h6>
            <button type="button" class="btn btn-primary btn-icon mg-t-10 rounded-20" style="margin-bottom: -25px" >
              <feather type="arrow-right" :width="32" :height="32"></feather>
            </button>
          </div>
        </router-link>

        <slot />

        <!-- <go-points
          class="mg-t-20"
          :userTaskId="$store.state.user.userInfo.profileId"
          v-if="
            $store.state.app.activeGroup.id != 9241 &&
              $store.state.app.activeGroup.id != 9249 &&
              $store.state.app.activeGroup.id != 9254 &&
              $store.state.app.activeGroup.id != 9235 && 
              $store.state.app.activeGroup.id != 9351 &&
              $store.state.app.activeGroup.id != 9157
          "
        /> -->
        <!-- && ($store.state.app.activeGroup.id == 9157 && $store.state.user.userInfo.locType4Code == 'member') -->
      </vue-custom-scrollbar>
    </div>
    <div class="text-center lms-sidebar-footer d-flex align-items-center justify-content-center">
      <div v-if="$store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249 || hasContactPage" class="text-muted mg-b-20">
        <router-link :to="{name: 'lmsContact'}" class="link-01">
          <feather type="phone"></feather>
          <span class="mg-l-10 tx-12">Холбоо барих</span>        
        </router-link>
      </div>
    </div>

    <b-modal
      v-model="miniEthic"
      header-class="bd-b-0"
      size=""
      content-class="rounded-20 pd-20"
      :title="`${$store.state.app.activeGroup.id == 9379 ? 'Зэргийн хүчинтэй хугацаа' : 'Үүргийн биелэлт'}`"
      footer-class="bd-t-0"
      hide-footer
      centered
    >
      <go-points class="mg-t-20" :userTaskId="$store.state.user.userInfo.profileId" />
    </b-modal>

    <b-modal v-model="miniMHVA" title="Мэргэжлийн хөгжлийн үйл ажиллагаа"
    size="lg"
    hide-footer
    centered
    >
      <div>
        <memberMonicpaMHVA @on-refresh="miniMHVA=false; miniEthic= true" />

      </div>
    </b-modal>

    <b-modal
      :transition-names="[]"
      class="no-padding-modal"
      v-model="examPointModal"
      :mask-closable="true"
      title="Шалгалт"
      hide-footer
      size="lg"
    >
      <exam-point v-if="examPointModal"></exam-point>
    </b-modal>
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";

import { localRead } from "@/libs/util";

import svgIcon from "@/assets/svg/all.vue";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import vueCustomScrollbar from "vue-custom-scrollbar";

import { request } from "@/api/all";

// Import particles.js as a global variable
// particles.js doesn't support ES6 imports properly

export default {
  components: {
    svgIcon,
    vueCustomScrollbar,
    goPoints: () => ({
      component: import("@/views/modules/lms/components/points"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    examPoint: () => ({
      component: import("@/views/modules/lms/student/components/examPoint"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 300,
      timeout: 20000,
    }),
    navBuddy: () => ({
      component: import("@/views/modules/lms/student/components/navBuddy.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 300,
      timeout: 20000,
    }),
    memberMonicpaMHVA: () => ({
      component: import("@/views/modules/lms/student/sections/memberMonicpaMHVA.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 300,
      timeout: 20000,
    }),
  },
  props: {
    counts: {
      type: Object,
      default: () => {},
    },
    zaaval: {
      type: Object,
      default: () => {},
    },
    obj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      examRs: [],
      examPointModal: false,
      miniMHVA: false,
      miniEthic: false,
      settedOrg:{
        hasValue: false,
        obj: {}
      },
      hasContactPage: false,
      hasPayment: false,
      hasEvent: false,
      hasEbarimt: false,
      auditrequestindex: 0,
      hasFeedback: false,
      myResBaseUrl: "https://res.gosmart.mn/",
      featuredCourse:{
        id: null,
        name: null,
      },
      navs:{
        home: true,
        library: true,
        calendar: true,
      },
      navbktypes:[],
      navbktypesCur: null,
      navcrsetypes:[],
      lmsNavType: 'Төрлөөр'
    };
  },
  created() {
    this.fetchResBase();
  },
  mounted() {
    if (localRead("settedOrg")){
      this.settedOrg.obj = JSON.parse(localRead("settedOrg"));
      this.settedOrg.hasValue= true;
    }
    this.fetchSpecies();

    let _lmsNavType = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "lmsNavType"
    );
    if (_lmsNavType.length > 0 && _lmsNavType[0].value != undefined) {
      this.lmsNavType = _lmsNavType[0].value;
    }

    let _pay = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "lmsAttendHasPayment"
    );
    if (_pay.length > 0 && _pay[0].value != undefined && _pay[0].value == "1") {
      this.hasPayment = true;
    }

    let _cpage = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "lmsHasContactPage"
    );
    if (_cpage.length > 0 && _cpage[0].value != undefined && _cpage[0].value == "1") {
      this.hasContactPage = true;
    }

    

    let _ebarimt = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "paymentEbarimt"
    );
    if (
      _ebarimt.length > 0 &&
      _ebarimt[0].value != undefined &&
      _ebarimt[0].value == "1"
    ) {
      this.hasEbarimt = true;
    }

    let _event = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "learnEventHide"
    );
    if (
      _event.length > 0 &&
      _event[0].value != undefined &&
      _event[0].value == "0"
    ) {
      this.hasEvent = true;
    }

    let _feedback = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "lmsFeedback"
    );
    if (
      _feedback.length > 0 &&
      _feedback[0].value != undefined &&
      _feedback[0].value == "1"
    ) {
      this.hasFeedback = true;
    }

    if ( (this.$store.state.app.activeGroup.id == 9241 || this.$store.state.app.activeGroup.id == 9249) && this.$store.state.user.userInfo.locType4Code == 'register' ){
      this.navs.home= false;
      //this.navs.library= false;
      this.navs.calendar= false;
    }

    //# monicpa
    if (this.$store.state.app.activeGroup.id == 9157){
      this.navs.home= false;
      this.navs.library= false;
      if(this.$store.state.user.userInfo.defaultTasks.organizationTaskId != null){
        this.auditrequestindex++;
      }
      this.fetchExamRs();
    }

    if(this.$store.state.app.activeGroup.id == 9379){
      this.fetchExamRs();
    }

    if(this.$store.state.app.activeGroup.id == 9241 || this.$store.state.app.activeGroup.id == 9249){
      this.initBookTypes();
    }
    // else if(this.$store.state.app.activeGroup.id == 9157){
    //   this.initCourseTypes();
    // }
    this.initCourseTypes();

    // Use global particlesJS function - particles.js v2.0.0
    if (typeof window !== 'undefined' && window.particlesJS) {
      window.particlesJS.load('particles-js', '/particles.json', function() {
        // console.log('callback - particles.js config loaded');
      });
    }
  },
  methods: {
    canNavigate(ex, i){
      let rv= true;
      if(this.$store.state.user.userInfo?.memberLicInfo?.ord > 0){
        rv= (ex.i1 == (this.$store.state.user.userInfo.memberLicInfo.ord+10));
      }else{
        rv = i==0;
      }
      return rv;
    },
    fetchExamRs(){
      request({
        api: { method: "GET", url: "type/getData" },
        params:{
          key: 'tmzExamLevel'
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.examRs= res.data.types;
          // console.log('this.examRs', this.examRs);
          // if(this.$store.state.app.activeGroup.id == 9379
          //   && this.$store.state.user.userInfo?.memberLicInfo?.ord > 0
          // ){
          //   this.examRs= this.examRs.filter(x=>x.i1 > this.$store.state.user.userInfo.memberLicInfo.ord);
          // }
        }
      });
    },
    initCourseTypes(){
      request({
        api: { method: "GET", url: "type/getData" },
        params:{
          key:'courseType'
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          //  
          if(this.$store.state.app.activeGroup.id == 9241 || this.$store.state.app.activeGroup.id == 9249 || this.$store.state.app.activeGroup.id ==9256){
            this.navcrsetypes= res.data.types;
          }
          else{
            this.navcrsetypes= res.data.types.filter(x=>x.field2=='1');
            console.log('this.navcrsetypes', this.navcrsetypes);
          }
           //field1 cover zuragtai davhtschihsan tul field 2 bolgov
        }
      });
    },
    initBookTypes(){
      request({
        api: { method: "GET", url: "type/getData" },
        params:{
          key:'lrnbk_type'
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.navbktypes= res.data.types.filter(x=>x.parentId==0);
        }
      });
    },
    fetchSpecies() {
      request({
        api: { method: "GET", url: "v2/Learn/GetHomeFeaturedCourse" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          if(res.data.course!=undefined && res.data.course!=null){
            this.featuredCourse.id=res.data.course.id;
            this.featuredCourse.name=res.data.course.name;
          }
        }
      });
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    courseNavExpanded() {
      let rv = true;
      if (
        this.$store.state.app.activeGroup.id == 9241 ||
        this.$store.state.app.activeGroup.id == 9249 ||
        this.$store.state.app.activeGroup.id == 9157 ||
        this.$store.state.app.activeGroup.id == 9379
      ) {
        if (this.$route.name == "lmsCourses") {
          rv = true;
        } else {
          rv = false;
        }
      } else if (
        !(
          this.$route.name == "lmsParticipant" ||
          this.$route.name == "lmsCourses"
        )
      ) {
        rv = false;
      }
      return rv;
      //$route.name=='lmsCourses' && ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)
    },
    // navopen(name) {
    //     if(name=='lmsCourses'){
    //       this.$router.push({
    //         name: 'lmsCourses',
    //         params:{
    //           md: 1,
    //           cnm: 'null',
    //           type:-1,
    //           d1: 'null',
    //           d2: 'null',
    //         }
    //       });
    //     }
    //     else if(this.$route.name!=name){
    //         this.$emit("route-changed");
    //         this.$router.push({ name: name });
    //     }
    // },
    // subNavOpen(id){
    //     this.$emit("sub-nav-change", id);
    // },
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    hasGroup(arr) {
      return hasOneOf([this.$store.state.app.activeGroup.id], arr);
    },
  },
};
</script>

<style></style>
